require('bootstrap/dist/js/bootstrap');

jQuery(document).on('turbolinks:load', () => {
  jQuery('#prescreenModal').modal({
    backdrop: 'static',
    show: true
  });
});
